"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var preact_1 = require("preact");
var TrackingDrawer_1 = require("./components/TrackingDrawer");
var requests_1 = require("./requests");
var SHIPMENT_LIMIT_IDX = 100;
var Tracking = /** @class */ (function () {
    function Tracking(shipmentIdOrIds, config, el) {
        this.shipmentIdOrIds = shipmentIdOrIds;
        this.config = config;
        this.el = el;
        this.isReady = false;
        this.isOpen = false;
        this.shipmentIds = [];
        this.fadeOut = {
            fade: {
                left: [{ opacity: 1 }, { opacity: 0 }],
                right: [{ opacity: 1 }, { opacity: 0 }],
            },
            slide: {
                left: [
                    { transform: 'translateX(0)' },
                    { transform: 'translateX(-100%)' },
                ],
                right: [
                    { transform: 'translateX(0)' },
                    { transform: 'translateX(100%)' },
                ],
            },
        };
        if (Array.isArray(this.shipmentIdOrIds)) {
            if (this.shipmentIdOrIds.length === 0) {
                throw new Error('Shipment id array is empty');
            }
            if (this.shipmentIdOrIds.some(function (shipmentId) { return typeof shipmentId !== 'string'; })) {
                throw new Error('Shipment id array contains non-string values');
            }
            if (this.shipmentIdOrIds.some(function (shipmentId) { return shipmentId.length === 0; })) {
                throw new Error('Shipment id array contains empty strings');
            }
            if (this.shipmentIdOrIds.length > SHIPMENT_LIMIT_IDX) {
                throw new Error("Shipment id array contains more than ".concat(SHIPMENT_LIMIT_IDX, " shipment ids"));
            }
        }
        this.shipmentIds = Array.isArray(this.shipmentIdOrIds)
            ? this.shipmentIdOrIds
            : [this.shipmentIdOrIds];
    }
    Tracking.prototype.open = function () {
        this.render();
        this.isOpen = true;
    };
    Tracking.prototype.render = function () {
        var _a;
        (0, preact_1.render)((0, jsx_runtime_1.jsx)(TrackingDrawer_1.TrackingDrawer, { shipmentIds: this.shipmentIds, config: this.config, onClose: (_a = this.config.onClose) !== null && _a !== void 0 ? _a : this.onClose.bind(this) }), this.el);
    };
    Tracking.prototype.close = function () {
        var _this = this;
        var _a, _b, _c;
        if (this.isOpen) {
            if (((_b = (_a = this.config.animation) === null || _a === void 0 ? void 0 : _a.out) === null || _b === void 0 ? void 0 : _b.type) != null) {
                var animation = (_c = document
                    .getElementsByClassName("artajs__drawer")[0]) === null || _c === void 0 ? void 0 : _c.animate(this.fadeOut[this.config.animation.out.type][this.config.style.position], {
                    duration: this.config.animation.out.duration,
                    easing: this.config.animation.out.easing,
                });
                animation.onfinish = function (e) {
                    e.preventDefault();
                    (0, preact_1.render)((0, jsx_runtime_1.jsx)("div", {}), _this.el);
                };
            }
            else {
                (0, preact_1.render)((0, jsx_runtime_1.jsx)("div", {}), this.el);
            }
        }
        this.isOpen = false;
    };
    Tracking.prototype.onClose = function (e) {
        e.preventDefault();
        this.close();
        this.isOpen = false;
    };
    Tracking.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var shipmentIdsOrErrors, newShipmentIds, _i, shipmentIdsOrErrors_1, shipmentIdOrError;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.shipmentIds.map(function (shipmentId) { return __awaiter(_this, void 0, void 0, function () {
                            var errors;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, (0, requests_1.validateShipment)(this.config, shipmentId)];
                                    case 1:
                                        errors = _a.sent();
                                        if (errors && Object.keys(errors).length > 0) {
                                            return [2 /*return*/, errors];
                                        }
                                        return [2 /*return*/, shipmentId];
                                }
                            });
                        }); }))];
                    case 1:
                        shipmentIdsOrErrors = _a.sent();
                        newShipmentIds = [];
                        for (_i = 0, shipmentIdsOrErrors_1 = shipmentIdsOrErrors; _i < shipmentIdsOrErrors_1.length; _i++) {
                            shipmentIdOrError = shipmentIdsOrErrors_1[_i];
                            if (typeof shipmentIdOrError === 'object') {
                                console.error('Shipment validation failed', shipmentIdOrError);
                            }
                            else {
                                newShipmentIds.push(shipmentIdOrError);
                            }
                        }
                        if (newShipmentIds.length === 0) {
                            return [2 /*return*/, Promise.reject('No valid shipment ids')];
                        }
                        this.isReady = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    return Tracking;
}());
exports.default = Tracking;
